import { Component, OnInit } from "@angular/core";
import { BargainingService } from "../../../../modules/recruitment/bargaining/bargaining.service";

@Component({
  selector: "app-widget-last-bargaining",
  templateUrl: "./widget-last-bargaining.component.html",
  styleUrls: ["./widget-last-bargaining.component.scss"],
})
export class WidgetLastBargainingComponent implements OnInit {
  public barganingList: any = [];

  constructor(public _bargainingService: BargainingService) {}

  async ngOnInit() {
    this.barganingList = await this._bargainingService.getBargainings();
    this.barganingList = this.barganingList
      .filter((item: any) => item.status_contract < 3 && item.status !== 2)
      .sort((a: any, b: any) => b.id - a.id)
      .slice(0, 5);
  }
}
